import { getOne } from './get-one-product';
import { search } from './search-for-products';
import { updateMetadata } from './update-metadata';

export const PosProductsAPI = {
  search,
  getOne,
  updateMetadata,
};
